export default `#version 300 es
precision highp float;
#define GLSLIFY 1

#pragma defines

float blinnPhongSpecular(
  vec3 lightDirection,
  vec3 viewDirection,
  vec3 surfaceNormal,
  float shininess) {

  //Calculate Blinn-Phong power
  vec3 H = normalize(viewDirection + lightDirection);
  return pow(max(0.0, dot(surfaceNormal, H)), shininess);
}

struct Light {
    vec4 position;
    vec3 color;
    float intensity;
    bool visible;
};

in vec3 worldPosition;
in vec3 vNormal;
in float vFragDepth;

out vec4 fragData[2];

uniform vec3 uColor;
uniform bool bShaded;
uniform vec3 cameraPosition;
uniform float fEmissive;
uniform vec3 ambient;
uniform Light lights[16];
uniform float uCameraScale;

#define shininess 64.0f

void main() {
    if(bShaded) {
        vec3 eyeDirection = normalize(cameraPosition - worldPosition);
        vec3 diffuse = vec3(0.0f);
        vec3 specular = vec3(0.0f);

        vec3 norm = normalize(vNormal);

        for(int i = 0; i < lights.length(); i++) {
            if(lights[i].visible) {
                vec3 lightDir = vec3(0.0f);
                float intensity = lights[i].intensity;
                if(lights[i].position.w == 0.0f) {
                    lightDir = normalize(-lights[i].position.xyz);
                } else {
                    vec3 d = lights[i].position.xyz - worldPosition;
                    lightDir = normalize(d);
                    intensity /= 1. + pow(length(d), 2.0f);
                }
                float diff = max(dot(norm, lightDir), 0.0f);
                vec3 color = lights[i].color * intensity;
                diffuse += diff * color;
                specular += blinnPhongSpecular(lightDir, eyeDirection, norm, shininess) * color;
            }
        }

        fragData[0].rgb = (diffuse + ambient + specular) * uColor;
    } else {
        fragData[0] = vec4(uColor, 1.f);
    }

    fragData[0].a = 1.0f;
    fragData[1] = vec4(fragData[0].xyz, fEmissive);

    gl_FragDepth = log2(vFragDepth) / uCameraScale;
}`